{
  "version": 1,
  "asset_id": "d406a26b-630a-4b44-a941-15202a91f40e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/d406a26b-630a-4b44-a941-15202a91f40e/hernando-galvalume-metal-roof-aerial-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/d406a26b-630a-4b44-a941-15202a91f40e/hernando-galvalume-metal-roof-aerial-768w.avif",
  "original_filename": "hernando-galvalume-metal-roof-aerial-768w.avif",
  "size": 33708,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
